import { Helmet } from 'react-helmet-async';
import { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { fToTitle } from '../../../utils/formatText';
import TicketSearch from '../../../components/dashboard/advanced-search/TicketSearch';
import OrderSearch from '../../../components/dashboard/advanced-search/OrderSearch';
import InvoiceSearch from '../../../components/dashboard/advanced-search/InvoiceSearch';

// ----------------------------------------------------------------------

export default function AdvancedSearch() {
  const [searchParams] = useSearchParams();
  const base = useMemo(() => searchParams.get('base'), [searchParams]);
  const baseLowerCase = useMemo(() => base?.toLowerCase(), [base]);
  return (
    <>
      <Helmet>
        <title>Advanced {fToTitle(base) ?? ""} Search | Platform Solutions</title>
      </Helmet>

      {baseLowerCase.includes('tickets') ? <TicketSearch/> :
      baseLowerCase.includes('orders') ? <OrderSearch /> :
      baseLowerCase.includes('invoicing') ? <InvoiceSearch/> : null}
    </>
  );
}
